<template>
    <section>
        <m-table-list ref="tableList" :fetch-list-func="fetchListFunc" :search-form.sync="filters">
            <template v-slot:search-items>
                <m-search-panel @searchBoxChange="handleSearch" isShowOpenButton @keyup.enter.native="handleSearch()">
                    <div slot="title">快速筛选</div>
                    <div class="filters">
                        <div class="query-item-all">
                            <div class="filter-item">
                                <div class="demonstration" style="margin-right:40px">关键词组名称</div>
                                <el-input v-model="filters.keywordGroupName" placeholder="关键词组名称" clearable></el-input>
                            </div>
                            <div class="filter-item">
                                <div class="demonstration">关键词</div>
                                <el-input v-model="filters.keyword" placeholder="关键词" clearable></el-input>
                            </div>
                            <div class="filter-item">
                                <div class="demonstration">关联分类</div>
                                <el-select v-model="filters.qaTypeId" placeholder="--未选择--" clearable>
                                    <el-option v-for="(item, index) in workCutList" :key="index" :value="item.parentTypeId" :label="item.parentQaTypeName"></el-option>
                                </el-select>
                            </div>
                            <div class="filter-item">
                                <div class="demonstration">备注信息</div>
                                <el-input v-model="filters.keywordGroupRemark" placeholder="备注信息" clearable></el-input>
                            </div>
                            <div class="filter-item">
                                <div class="demonstration">启用状态</div>
                                <el-select v-model="filters.status" placeholder="--未选择--" clearable>
                                    <el-option value="" label="不限"></el-option>
                                    <el-option value="Enable" label="是" />
                                    <el-option value="Disable" label="否" />
                                </el-select>
                            </div>

                        </div>
                        <div class="filter-item buttons">
                            <el-button type="primary" size="small" class="query-btn" @click="handleSearch">查询</el-button>
                            <el-button type="primary" size="small" plain @click="handleClearSearchForm">重置</el-button>
                        </div>
                    </div>
                </m-search-panel>
            </template>
            <template v-slot:page-title>
                <div class="page-tabe-title">
                    <div class="right">
                        <span class="line"></span>
                        <div>数据列表</div>
                    </div>
                    <div class="left">
                        <el-button type="primary" size="small" class="add-btn" @click="$router.push({name: 'privilege.keywords.details'})">+添加</el-button>
                    </div>
                </div>
            </template>
            <template v-slot:table-columns>
                <el-table-column label="关键词组名称" prop="keywordGroupName"></el-table-column>
                <el-table-column label="关联分类" prop="qaTypeName"></el-table-column>
                <el-table-column label="是否启用" prop="status" width="120px">
                    <template v-slot="{row}">{{row.status==="Enable"?'是':'否'}}</template>
                </el-table-column>
                <el-table-column label="备注" prop="keywordGroupRemark">
                </el-table-column>
                <el-table-column label="创建时间" prop="created" width="150px" align="center">
                    <template slot-scope="{row}">{{row.created | dateTime('yyyy-MM-dd hh:mm')}}</template>
                </el-table-column>
                <el-table-column label="操作" width="140px">
                    <template slot-scope="{row}">
                        <el-button @click="$router.push({name: 'privilege.keywords.details', query: { id: row.id }})" type="text" size="small">编辑</el-button>
                        <el-button @click="deleteRow(row.id)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
                    </template>
                </el-table-column>
            </template>
        </m-table-list>
    </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";

export default {
    name: "privilege.keywords.list",
    data() {
        return {
            filters: {
                pageNo: 1,
                pageSize: 10,
                keywordGroupName: "",
                keyword: "",
                status: "",
                qaTypeId: "",
                keywordGroupRemark: "",
                status: "",
            },
            time: "",
            workCutList: [],
        };
    },
    components: {
        "m-table-list": tableList,
    },
    created() {
        api.dropDownList.getWorkCut().then((res) => {
            //工单分类下拉
            this.workCutList = res.data.data;
        });
    },
    methods: {
        handleSearch() {
            this.$refs.tableList.handleSearch();
        },
        handleClearSearchForm() {
            this.$refs.tableList.resetSearchForm();
        },
        fetchListFunc: api.keywords.getList,
        deleteRow(id) {
            this.$confirm("是否删除", "提示", {
                confirmButtonText: "确定",
                confirmButtonClass: "confirmBtn",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                api.keywords
                    .deleteById({
                        id,
                    })
                    .then((res) => {
                        this.$message.success("删除成功");
                        this.$nextTick(() => {
                            this.$refs.tableList.getMainData();
                        });
                    });
            });
        },
    },
};
</script>
